import { Flex, Typography } from 'antd'
import { FC, useMemo } from 'react'
import { useGetRewindQueueEntriesQuery } from '../../../../../../../store/api/rewind-queue-entries-api'
import Machine from '../../../../../../../types/api/machine'
import { getRewindQueueQuery } from '../../../../constants/query-params'

interface MachineQueueTitleProps {
    machine: Machine
}

const MachineQueueTitle: FC<MachineQueueTitleProps> = ({ machine }) => {
    const queryParams = useMemo(() => getRewindQueueQuery(machine.documentId), [machine.documentId])
    const { data } = useGetRewindQueueEntriesQuery(queryParams)

    return (
        <Flex justify='space-between'>
            <Typography.Text strong>{machine.name}</Typography.Text>
            <Typography.Text>{data?.data.length ?? 0} зад</Typography.Text>
        </Flex>
    )
}

export default MachineQueueTitle
